<template>
  <span>
    <v-text-field
      v-if="editing"
      :disabled="disabled"
      :maxlength="maxlength"
      :value="text"
      @change="changed"
      :rules="all_rules"
      :label="label"
      ref="atinput"
      validate-on-blur
      @focusout.native="blur"
      :autofocus="autofocus"
    ></v-text-field>
    <v-icon v-else>{{ trxtext }}</v-icon>
  </span>
</template>

<script>
import ATInputMixin from "./ATInputMixin.js";

export default {
  mixins: [ATInputMixin],
  computed: {
    all_rules() {
      let rules = [];
      if (this.required) rules.push(value => !!value || "Required.");
      return rules;
    }
  }
};
</script>